import { isNullOrUndefined } from 'src/app/shared/utilities/obj-utilities';

export function convertHourToShiftChar(startHour: number): string {
    if (isNullOrUndefined(startHour)) {
        return '';
    }

    return startHour >= 5 && startHour <= 12 ? 'D' : startHour > 12 && startHour < 15 ? 'M' : 'N';
}

export function convertHourToShiftTypeId(startHour: number): number {
    if (isNullOrUndefined(startHour)) {
        return startHour;
    }

    return startHour >= 5 && startHour <= 12 ? 1 : startHour > 12 && startHour < 15 ? 2 : 3;
}
